import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M9.41679 15.5836V10.6269L4.271 4.41699H15.7292L10.5834 10.6269V15.5836H9.41679Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map